import { Dialog, Language } from '@eta/components';
import { Label } from '@fluentui/react';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, ConnectedProps } from 'react-redux';
import { UIHelpers } from '../../helpers/UIHelpers';
import { ClaimLookupDto, GetRepresentationDetailsExternalResponseDto, LookupsDto } from '../Service/proxy';
import { ServiceCreator } from '../Service/client';
import './ViewPermessions.scss';
import { ReduxState } from '../../common/reducers';

export interface ViewPermessionsProps {
    RepresentationId: number;
    hidden: boolean;
    onClose: () => void;
    propsCurrentLanguage: Language;
}
export class CustomLookupsDto {
    id?: number;

    code?: string;

    name?: string;

    description!: string | undefined;

    parentCode?: string;

    checked?: boolean;
}
export enum Permessions {
    CanViewDocument = 'ViewDoc',
    CanSubmitDocument = 'SubmitDoc',
    CanCancelDocument = 'CancelDoc',
    CanRejectDocument = 'RejectDoc',
    CanExportDocument = 'ExportDoc',
    CanDeclineCancellation = 'DecCancelDoc',
    CanDeclineRejection = 'DecRejectDoc',
    CanViewNotifications = 'ViewNotification',
    CanManageTaxpayerCodes = 'MngCodes'
}
const mapStateToProps = (state: ReduxState) => ({
    currentLanguage: state.reduxlanguage.language,
});


const connector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof connector>;
const ViewPermessions: FC<PropsFromRedux & ViewPermessionsProps> = (props: PropsFromRedux & ViewPermessionsProps ) => {
    const {RepresentationId,hidden,onClose,propsCurrentLanguage} = props;
    const { t } = useTranslation(['resources', 'common']);
    const [RepresentationObj, setRepresentationObj] = useState<GetRepresentationDetailsExternalResponseDto | undefined>();
    const [currentModuleLanguage, setCurrentModuleLanguage] = useState<Language>();
    const [claimsArray, setClaimsArray] = useState<CustomLookupsDto[]>([]);
    const [claimsCategory,setClaimsCategory] = useState<LookupsDto[]>([]);
    const [claims,setClaims] = useState<ClaimLookupDto[]>([]);   
     const MapFromRepresentationToCustom=(claimsOriginal: ClaimLookupDto[],RepresentationDetails: GetRepresentationDetailsExternalResponseDto): CustomLookupsDto[]=>{
        const res: CustomLookupsDto[]=[];
        claimsOriginal.forEach(item => {
            const CustomItem: CustomLookupsDto = new CustomLookupsDto();
            CustomItem.id = item.id;
            CustomItem.code = item.code;
            CustomItem.name = item.name;
            CustomItem.parentCode = item.parentCode;
            CustomItem.description = item.description;
            switch (item.code) {
                case Permessions.CanCancelDocument:
                    CustomItem.checked = RepresentationDetails.canCancelDocument ?? false;
                    break;
                case Permessions.CanDeclineCancellation:
                    CustomItem.checked = RepresentationDetails.canDeclineCancellation ?? false;
                    break;
                case Permessions.CanDeclineRejection:
                    CustomItem.checked = RepresentationDetails.canDeclineRejection ?? false;
                    break;
                case Permessions.CanExportDocument:
                    CustomItem.checked = RepresentationDetails.canExportDocument ?? false;
                    break;
                case Permessions.CanManageTaxpayerCodes:
                    CustomItem.checked = RepresentationDetails.canManageTaxpayerCodes ?? false;
                    break;
                case Permessions.CanRejectDocument:
                    CustomItem.checked = RepresentationDetails.canRejectDocument ?? false;
                    break;
                case Permessions.CanSubmitDocument:
                    CustomItem.checked = RepresentationDetails.canSubmitDocument ?? false;
                    break;
                case Permessions.CanViewDocument:
                    CustomItem.checked = RepresentationDetails.canViewDocument ?? true;
                    break;
                case Permessions.CanViewNotifications:
                    CustomItem.checked = RepresentationDetails.canViewNotifications ?? false;
                    break;

                default:
                    CustomItem.checked = CustomItem.id === 1;
                    break;
            }
            res.push(CustomItem);
        });
        return res.sort((a, b) => (a.id ?? 0) - (b.id ?? 0));
    };
    const getRepresntationDetails = async () => {
        const client = ServiceCreator.getProviderManagementPublicClient();
        const RepresntationDetails = await client.getRepresentationDetails(RepresentationId ?? 0 /* 230 */);
        setRepresentationObj(RepresntationDetails);
    };
    const getConfigs = async () => {
        const client = ServiceCreator.getProviderManagementPublicClient();
        const Config = await client.getConfig();
        setClaimsCategory(Config.claimsCategory??[]);
        setClaims(Config.claims??[]);

    };
    useEffect(() => {
        if (((!claimsCategory && !claims)) || currentModuleLanguage?.lang !== propsCurrentLanguage.lang) {
            setCurrentModuleLanguage(propsCurrentLanguage);
            getConfigs();

        }
    }, [propsCurrentLanguage, currentModuleLanguage, claims, claimsCategory, getConfigs]);

    useEffect(() => {
        if (RepresentationObj === undefined && (RepresentationId ?? 0) > 0) {
            getRepresntationDetails();
        }
    }, [RepresentationObj, RepresentationId]);
    useEffect(() => {
        if ((claims?.length ?? 0) > 0 && claimsArray.length === 0 && (RepresentationObj)) {


            setClaimsArray(MapFromRepresentationToCustom(claims ?? [], RepresentationObj));
        }
    }, [claims, claimsArray, RepresentationObj]);
    return (
        <Dialog
            containerClassName='viewPermessions'
            hidden={hidden}
            onDismiss={() => {
                onClose();
            }}
            maxWidth={750}
            title={t('RepresentationDetails')}
        >
            <div className="intermediary">
                <div className='content'>
                    <div className='taxpayerName'>
                        <Label>
                            {UIHelpers.getLocalizedName(RepresentationObj?.intermediaryNamePrimaryLang, RepresentationObj?.intermediaryNameSecondaryLang, propsCurrentLanguage)}
                        </Label>
                    </div>

                    <div className="bodyLine">
                        <div className='c-grid' >
                            <Label className='titleDate'>{t('Activefrom')}</Label>
                            <Label className='date'>
                                {UIHelpers.getLocalizedDateTime(
                                    'Date',
                                    RepresentationObj?.representationFrom
                                )}
                            </Label>
                        </div>
                        <div className='c-grid'>
                            <Label className='titleDate'>{t('Activeto')}</Label>
                            <Label className='date'>
                                {UIHelpers.getLocalizedDateTime(
                                    'Date',
                                    RepresentationObj?.representationTo
                                )}
                            </Label>
                        </div>
                    </div>
                    
                    <Label>{t('Permessions')}</Label>
                    {claimsCategory?.map((category) => {
                        const checkedPermessions = claimsArray.filter(x => x.checked && (Number(x.parentCode ?? 0) === category.id ?? 0));
                        const checkedPermessionsStr = Array.prototype.map.call(checkedPermessions, s => s.name).toString();
                        if (checkedPermessions.length === 0) return (<></>);
                        return (
                            <div className='taxpayerDetails'>
                                <Label className='bold'>{category?.name ?? ''}</Label>
                                <span>{checkedPermessionsStr}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </Dialog>
    );
};
export default connector(ViewPermessions);
